import { LEADERBOARD_TABS_REQUEST, LEADERBOARD_TABS_SUCCESS, LEADERBOARD_TABS_FAILURE } from '../action/types'

const initialState = {
  tabs: [],
  loading: true,
  error: '',
}

export const leaderboardtabs = (state = initialState, action) => {
  switch (action.type) {
    case LEADERBOARD_TABS_REQUEST:
      return {
        state,
        loading: true,
      }
    case LEADERBOARD_TABS_SUCCESS:
      return {
        data: action.payload,
        loading: false,
      }
    case LEADERBOARD_TABS_FAILURE:
      return {
        data: [],
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}
